function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="M23 12h-3A8 8 0 0 0 7.74 5.24L9.2 6.7A5.87 5.87 0 0 1 12 6a6 6 0 0 1 6 6h-3l4 4zM9 12L5 8l-4 4h3a8 8 0 0 0 12.26 6.76L14.8 17.3a5.87 5.87 0 0 1-2.8.7 6 6 0 0 1-6-6z" /></svg>;
});